<template>
  <div>
    <!-- IS: {{ isSubscribed }} -->
    <v-card
      v-if="items && hasItems"
      flat
      color="#fffaf0"
      style="border: 1px solid #e6e1da"
      class="darkerCardText pa-2 ma-2"
    >
      <div class="overline">Related Resources</div>
      <div class="">
        <!-- {{ items }} -->
        <v-divider></v-divider>

        <v-list dense style="background-color: transparent">
          <v-list-item-group
            v-for="(moduleObj, moduleKey) in items"
            :key="moduleKey"
            class="moduleList"
          >
            <v-subheader>
              {{ moduleObj.label }}

              <span
                v-if="moduleObj.pro && !isSubscribed"
                class="red--text mx-1 caption"
              >
                (Requires EyeDock PRO)</span
              ></v-subheader
            >
            <v-list-item
              v-for="(item, i) in moduleObj.items"
              :key="'item' + i"
              :to="urlForItem(moduleObj, item)"
            >
              <v-list-item-icon v-if="moduleObj.hasImage">
                <div style="width: 70px">
                  <v-img
                    v-if="item.image"
                    contain
                    height="30"
                    max-width="60"
                    :src="item.image"
                  ></v-img>
                </div>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >{{ item.label }}
                  <span v-if="item.pro && !isSubscribed" class="mx-1 caption">
                    <span class="red--text"> (PRO) </span>
                    <a v-if="item.learnMore" class="" :href="item.learnMore"
                      >About</a
                    ></span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-1"></v-divider>
          </v-list-item-group>
        </v-list>
      </div>
    </v-card>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "SeeAlso",
  props: {
    identifier: null,
    identifier_type: null,
    referrer: null, // eg "ICD10" (this will tell the backend not to refer to the same module)
    data: null, // if want to pass in data directly instead of calling api. should be in this format
  },
  mixins: [UserMixin],
  data: function () {
    return {
      items: null,
      //   meta: null,
    };
  },
  methods: {
    callApi() {
      if (!this.identifierArray) return;
      let paramString = "?";
      //   let identifier = this.identifier;
      //   if (!Array.isArray(identifier)) identifier = [identifier];
      this.identifierArray.forEach((id) => {
        paramString += "q[]=" + id + "&";
      });
      if (this.identifier_type) paramString += "&type=" + this.identifier_type;
      if (this.referrer) paramString += "&referrer=" + this.referrer;
      ApiServices.genericApiCall("seeAlso", paramString)
        .then((response) => {
          //   console.log(response);
          this.items = response.data.items;
          //   this.meta = response.data.meta;
          if (response.error) this.logError(response.error);
          //   console.log(response.items);
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    logError(error) {
      console.log("api error for code " + this.identifier, error);
    },
    urlForItem(moduleObj, item) {
      if (!moduleObj || !item) return null;
      let url = item.url;
      let learnMore = moduleObj.learnMore;
      let pro = moduleObj.pro;
      let rtnUrl = pro && !this.isSubscribed ? learnMore : url;
      return rtnUrl;
    },
  },
  computed: {
    hasItems: function () {
      return this.items && Object.keys(this.items).length > 0;
    },
    identifierArray() {
      if (!this.identifier) return null;
      if (Array.isArray(this.identifier)) return this.identifier;
      // split the identifier into an array at the comma or hyphen character
      let arr = this.identifier.split(/,|-/);
      return arr;
    },
  },
  watch: {
    identifier: function () {
      this.callApi();
    },
    data: function () {
      this.items = this.data.items;
      //   this.meta = this.data.meta;
    },
  },
  mounted() {
    if (this.identifier) {
      this.callApi();
    }
    if (this.data) {
      this.items = this.data.items;
      //   this.meta = this.data.meta;
    }
  },
};
</script>

<style scoped>
.hover {
  background-color: #ffefce;
}
</style>
